/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import {
    Card,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
    Toolbar,
    Typography,
    CardContent,
    Tooltip,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import BottomBar from "../../../components/BottomBar/BottomBar";
import Select from "react-select";
import { DateTimePicker } from "@material-ui/pickers";

class F304PushNotificationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            recordId: this.props.match?.params?.recordId || 0,

            // ── Core Fields ──
            title: "",
            titleError: "",
            body: "",
            bodyError: "",

            // ── Audience ──
            // "0" = Specific User, "1" = All Users, "2" = Unregistered Users
            audienceType: "1",

            usersList: [],
            selectedUsersList: [],

            // ── Schedule ──
            // "now" = Send Now, "schedule" = Schedule
            sendType: "now",
            scheduledAt: null,
            scheduledAtError: "",

            // ── Route / Path / Params ──
            selectedRoute: 0,
            routesOption: [],
            selectedRoutePath: 0,
            routesPathOption: [],
            params: [],
            paramsJSON: {},

            // ── UI State ──
            isOpenSnackbar: false,
            snackbarMessage: "",
            snackbarSeverity: "",
            isLoginMenu: false,
            isReload: true,
            isLoading: false,
        };
    }

    // ── Lifecycle ──

    componentDidMount = async () => {
        await Promise.all([
            this.getUsersData(),
            this.getRoutesData(),
        ]);

        const id = this.props.match?.params?.recordId;
        if (id && id != 0) {
            this.setState({ recordId: id });
            this.getData(id);
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.match?.params?.recordId != nextProps.match?.params?.recordId) {
            if (nextProps.match?.params?.recordId != 0) {
                this.getData(nextProps.match?.params?.recordId);
            } else {
                window.location.reload();
            }
        }
    }

    // ── Params Helpers ──

    buildParamsJSON = (params) => {
        return params
            .filter((p) => p.key.trim() !== "")
            .reduce((acc, p) => ({
                ...acc,
                [p.key]: p.value.trim() !== "" && !isNaN(p.value) ? Number(p.value) : p.value,
            }), {});
    };

    handleAddParam = () => {
        this.setState((prev) => {
            const params = [...prev.params, { key: "", value: "" }];
            return { params, paramsJSON: this.buildParamsJSON(params) };
        });
    };

    handleRemoveParam = (index) => {
        this.setState((prev) => {
            const params = prev.params.filter((_, i) => i !== index);
            return { params, paramsJSON: this.buildParamsJSON(params) };
        });
    };

    handleParamChange = (index, field, value) => {
        this.setState((prev) => {
            const params = [...prev.params];
            params[index] = { ...params[index], [field]: value };
            return { params, paramsJSON: this.buildParamsJSON(params) };
        });
    };

    // ── API Calls ──

    getUsersData = async () => {
        const res = await HttpRequest(
            "GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300CommonUsersView`,
            null,
            "authorizeJson"
        );
        if (res.isSuccess && res.data?.length > 0) {
            const usersList = res.data.map((u) => ({
                value: u.id,
                label: `${u.id} - ${u.displayName}`,
                id: u.id,
                isFixed: false,
                isDisabled: false,
            }));
            this.setState({ usersList });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
    };

    getRoutesData = async () => {
        const res = await HttpRequest(
            "GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300MobileApplicationRouteView`,
            null,
            "authorizeJson"
        );
        if (res.isSuccess && res.data?.length > 0) {
            this.setState({ routesOption: res.data });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
    };

    getRoutesPathsData = async (routeId) => {
        const data = new FormData();
        data.append("routeId", routeId);
        const res = await HttpRequest(
            "POST",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300MobileApplicationRoutePathsView`,
            data,
            "authorize"
        );
        if (res.isSuccess && res.data?.length > 0) {
            this.setState({ routesPathOption: res.data });
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
        }
    };

    getData = async (id) => {
        const res = await HttpRequest(
            "GET",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C304PushNotificationsView?recordId=${id}`,
            null,
            "authorizeJson"
        );
        if (res.isSuccess && res.data?.length > 0) {
            const d = res.data[0];

            let parsedParams = [];
            let parsedParamsJSON = {};
            if (d.paramsJSON) {
                try {
                    parsedParamsJSON = typeof d.paramsJSON === "string"
                        ? JSON.parse(d.paramsJSON)
                        : d.paramsJSON;
                    parsedParams = Object.entries(parsedParamsJSON).map(([key, value]) => ({
                        key,
                        value: String(value),
                    }));
                } catch (e) {
                    console.error("Failed to parse paramsJSON:", e);
                }
            }

            this.setState({
                title: d.title || "",
                body: d.body || "",
                audienceType: d.audienceType != null ? String(d.audienceType) : "1",
                selectedUsersList: Array.isArray(d.selectedUsersList)
                    ? d.selectedUsersList
                    : [],
                sendType: d.scheduledAt ? "schedule" : "now",
                scheduledAt: d.scheduledAt && d.scheduledAt !== "-"
                    ? (() => {
                        // Parse "08/04/2026 04:36 PM" → Date object
                        const [datePart, timePart, meridiem] = d.scheduledAt.split(" ");
                        const [day, month, year] = datePart.split("/");
                        let [hours, minutes] = timePart.split(":");
                        hours = parseInt(hours);
                        if (meridiem === "PM" && hours !== 12) hours += 12;
                        if (meridiem === "AM" && hours === 12) hours = 0;
                        return new Date(year, month - 1, day, hours, minutes, 0);
                    })()
                    : null,
                selectedRoute: d.pageRouteId || 0,
                selectedRoutePath: d.pageRoutePathId || 0,
                params: parsedParams,
                paramsJSON: parsedParamsJSON,
            });

            if (d.pageRouteId) {
                this.getRoutesPathsData(d.pageRouteId);
            }
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
            else this.handleSnackbar(true, res.message || "Failed to load data", "error");
        }
    };

    // ── Handlers ──

    handleSnackbar = (isOpen, message, severity) => {
        this.setState({ isOpenSnackbar: isOpen, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleRouteChange = (e) => {
        this.setState({ selectedRoute: e.target.value, selectedRoutePath: 0, routesPathOption: [], params: [], paramsJSON: {} });
        this.getRoutesPathsData(e.target.value);
    };

    handleRoutePathChange = (e) => {
        this.setState({ selectedRoutePath: e.target.value });
    };

    // ── Validation ──

    isFormValid = () => {
        let isValid = true;
        const errors = {};

        if (!this.state.title.trim()) {
            isValid = false;
            errors.titleError = "Please enter notification title.";
        }
        if (!this.state.body.trim()) {
            isValid = false;
            errors.bodyError = "Please enter notification body.";
        }
        if (this.state.audienceType === "0" && (!this.state.selectedUsersList || this.state.selectedUsersList.length === 0)) {
            isValid = false;
            this.handleSnackbar(true, "Please select at least one user.", "error");
        }
        if (this.state.sendType === "schedule" && !this.state.scheduledAt) {
            isValid = false;
            errors.scheduledAtError = "Please select a scheduled date and time.";
        }
        if (this.state.selectedRoute && this.state.selectedRoute !== 0 && this.state.selectedRoute !== "0") {
            if (!this.state.selectedRoutePath || this.state.selectedRoutePath == "0") {
                isValid = false;
                this.handleSnackbar(true, "Please select mobile app path.", "error");
            }
            if (this.state.params.length > 0) {
                for (let i = 0; i < this.state.params.length; i++) {
                    const param = this.state.params[i];
                    if (!param.key.trim()) {
                        isValid = false;
                        this.handleSnackbar(true, `Param row ${i + 1}: Key is required.`, "error");
                        break;
                    }
                    if (!param.value.toString().trim()) {
                        isValid = false;
                        this.handleSnackbar(true, `Param row ${i + 1}: Value is required for key "${param.key}".`, "error");
                        break;
                    }
                }
                const keys = this.state.params.map((p) => p.key.trim());
                const duplicates = keys.filter((k, i) => keys.indexOf(k) !== i);
                if (duplicates.length > 0) {
                    isValid = false;
                    this.handleSnackbar(true, `Duplicate param key: "${duplicates[0]}".`, "error");
                }
            }
        }

        this.setState(errors);
        return isValid;
    };

    // ── Submit ──

    onClickSubmit = () => {
        document.getElementById("F300PushNotifSubmitBtn").click();
    };

    submitForm = async (e) => {
        e.preventDefault();
        if (!this.isFormValid()) return;

        this.setState({ isLoading: true });

        const data = new FormData();
        data.append("recordId", this.state.recordId);
        data.append("title", this.state.title.trim());
        data.append("body", this.state.body.trim());
        data.append("audienceType", this.state.audienceType);

        // Users — only for Specific User
        if (this.state.audienceType === "0") {
            this.state.selectedUsersList.forEach((u) => data.append("userId", u.id));
        }

        // Schedule
        data.append("sendType", this.state.sendType);
        data.append("scheduledAt", this.state.sendType === "schedule" && this.state.scheduledAt
            ? new Date(this.state.scheduledAt).toISOString()
            : "");

        // Route / Path / Params
        data.append("pageRouteId", this.state.selectedRoute || 0);
        data.append("pagePathRouteId", this.state.selectedRoutePath || 0);
        data.append("paramsJSON", JSON.stringify(this.state.paramsJSON));

        const res = await HttpRequest(
            "POST",
            `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C304PushNotificationsSave`,
            data,
            "authorize"
        );

        if (res.isSuccess) {
            this.handleSnackbar(true, "Notification saved successfully.", "success");
            setTimeout(() => window.location.reload(), 1500);
        } else {
            if (res.statusCode === 401) this.setState({ isLoginMenu: true });
            else this.handleSnackbar(true, res.message || "Save failed.", "error");
        }

        this.setState({ isLoading: false });
    };

    viewReport = async () => {
        window.location = "#/F304PushNotificationReport";
    };

    render() {
        const {
            title, titleError, body, bodyError,
            audienceType, sendType, scheduledAt, scheduledAtError,
            selectedRoute, routesOption, selectedRoutePath, routesPathOption,
            usersList,
        } = this.state;

        return (
            <Fragment>
                <LoginMenu
                    reload={this.state.isReload}
                    open={this.state.isLoginMenu}
                    handleClose={() => this.setState({ isLoginMenu: false })}
                />
                <CustomizedSnackbar
                    isOpen={this.state.isOpenSnackbar}
                    message={this.state.snackbarMessage}
                    severity={this.state.snackbarSeverity}
                    handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
                    autoHideDuration={3000}
                />

                <Grid container xs={12} direction="column" justifyContent="center" alignItems="center" style={{ padding: 10 }}>
                    <Toolbar>
                        <NavBar isAuthorize title="Push Notifications" />
                    </Toolbar>

                    <Card style={{ width: "98%", paddingBottom: 100, paddingLeft: 20, paddingRight: 20 }}>
                        <CardContent>
                            <Typography variant="h5" color="primary" style={{ fontWeight: 700, marginBottom: 8 }}>
                                {this.state.recordId == 0 ? "New Push Notification" : "Edit Push Notification"}
                            </Typography>

                            {/* ── Title & Body ── */}
                            <Grid container spacing={2} style={{ marginTop: 8 }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Title *"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        value={title}
                                        inputProps={{ maxLength: 250 }}
                                        error={!!titleError}
                                        helperText={titleError}
                                        onChange={(e) => this.setState({ title: e.target.value, titleError: "" })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Body *"
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        multiline
                                        rows={3}
                                        value={body}
                                        inputProps={{ maxLength: 500 }}
                                        error={!!bodyError}
                                        helperText={bodyError}
                                        onChange={(e) => this.setState({ body: e.target.value, bodyError: "" })}
                                    />
                                </Grid>
                            </Grid>

                            {/* ── Audience Type ── */}
                            <div style={{ marginTop: 24, marginBottom: 8 }}>
                                <FormLabel component="legend">Send to</FormLabel>
                                <RadioGroup
                                    row
                                    value={audienceType}
                                    onChange={(e) => this.setState({ audienceType: e.target.value, selectedUsersList: [] })}
                                >
                                    <FormControlLabel value="0" control={<Radio style={{ color: "#3f51b5" }} />} label="Specific User" />
                                    <FormControlLabel value="1" control={<Radio style={{ color: "#3f51b5" }} />} label="All Users" />
                                    <FormControlLabel value="2" control={<Radio style={{ color: "#3f51b5" }} />} label="Unregistered Users" />
                                </RadioGroup>
                            </div>

                            {/* ── User Select — only for Specific User ── */}
                            {audienceType === "0" && (
                                <Grid container item xs={12} sm={6} style={{ position: "relative", zIndex: 10, marginBottom: 20 }}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle2" color="textSecondary" style={{ paddingBottom: 5 }}>
                                            Select Users *
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Select
                                            isMulti
                                            value={this.state.selectedUsersList}
                                            options={usersList}
                                            onChange={(e) => this.setState({ selectedUsersList: e || [] })}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Search users..."
                                            styles={{
                                                option: (base) => ({ ...base, backgroundColor: "#FFFFFF" }),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            )}

                            {/* ── Page Route & Path ── */}
                            <Grid container spacing={2} style={{ marginTop: 8, marginBottom: 8 }}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        value={selectedRoute}
                                        onChange={this.handleRouteChange}
                                        label="Page Route"
                                        select fullWidth variant="outlined" size="small"
                                    >
                                        <MenuItem value={0}>— None —</MenuItem>
                                        {routesOption.map((opt) => (
                                            <MenuItem key={opt.id} value={opt.id}>{opt.label}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        value={selectedRoutePath}
                                        onChange={this.handleRoutePathChange}
                                        label="Mobile App Path"
                                        select fullWidth variant="outlined" size="small"
                                        disabled={!selectedRoute || selectedRoute == 0}
                                    >
                                        <MenuItem value={0}>— None —</MenuItem>
                                        {routesPathOption.map((opt) => (
                                            <MenuItem key={opt.id} value={opt.id}>{opt.urlPath}</MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>



                            {/* ── Send Type ── */}
                            <div style={{ marginTop: 16, marginBottom: 8 }}>
                                <FormLabel component="legend">When to send</FormLabel>
                                <RadioGroup
                                    row
                                    value={sendType}
                                    onChange={(e) => this.setState({ sendType: e.target.value, scheduledAt: null, scheduledAtError: "" })}
                                >
                                    <FormControlLabel value="now" control={<Radio style={{ color: "#3f51b5" }} />} label="Send Notification Now" />
                                    <FormControlLabel value="schedule" control={<Radio style={{ color: "#3f51b5" }} />} label="Schedule Notification" />
                                </RadioGroup>
                            </div>

                            {/* ── Date Time Picker — only for Schedule ── */}
                            {sendType === "schedule" && (
                                <Grid container item xs={12} sm={6} style={{ marginBottom: 20 }}>
                                    <DateTimePicker
                                        label="Schedule Date & Time *"
                                        inputVariant="outlined"
                                        fullWidth
                                        size="small"
                                        value={scheduledAt}
                                        onChange={(date) => {
                                            if (date) {
                                                date.setSeconds(0, 0);
                                            }
                                            this.setState({ scheduledAt: date, scheduledAtError: "" });
                                        }}
                                        disablePast
                                        minDate={new Date()}
                                        minDateMessage="Date & time cannot be in the past."
                                        format="dd-MM-yyyy HH:mm"
                                        ampm={false}
                                        error={!!scheduledAtError}
                                        helperText={scheduledAtError}
                                    />
                                </Grid>
                            )}

                        </CardContent>
                    </Card>

                    <form noValidate onSubmit={this.submitForm}>
                        <input id="F300PushNotifSubmitBtn" type="submit" hidden />
                    </form>

                    <BottomBar
                        leftButtonText="View All"
                        leftButtonAction={() => { this.viewReport() }}
                        rightButtonText={this.state.isLoading ? "Saving..." : "Submit"}
                        rightButtonAction={this.onClickSubmit}
                    />
                </Grid>
            </Fragment>
        );
    }
}

F304PushNotificationForm.propTypes = {
    match: PropTypes.object,
};

F304PushNotificationForm.defaultProps = {
    match: { params: { recordId: 0 } },
};

export default F304PushNotificationForm;